import { CButtonToolbar } from './CButtonToolbar.js';
import { CButtonGroup } from './CButtonGroup.js';

const CButtonGroupPlugin = {
    install: (app) => {
        app.component(CButtonToolbar.name, CButtonToolbar);
        app.component(CButtonGroup.name, CButtonGroup);
    },
};

export { CButtonGroup, CButtonGroupPlugin, CButtonToolbar };
//# sourceMappingURL=index.js.map
